#!/usr/bin/env node
import { runHumanCli } from '../src/cli/human-cli.js'

runHumanCli().catch((err) => {
  console.error(err instanceof Error ? err.message : String(err))
  process.exit(1)
})

